import {WebchargeSettingDto} from "@/model/WebchargeSettingDto";
import {HelperFunctions} from "@/scripts/Common/HelperFunctions";
import {Constants} from "@/scripts/Common/Constants";

export class WebchargeSetting {
    public webchargeConfigurationModel:WebchargeSettingDto = new WebchargeSettingDto();

    public hasSpecificChargingDays:boolean = false;
    public chargingDays:Array<string> | undefined = undefined;
    public hasConfigurationError:boolean = false;
    public configurationErrors:object = {};

    constructor(webchargeConfigurationModel?:WebchargeSettingDto) {
        if(!!webchargeConfigurationModel)
            this.setValues(webchargeConfigurationModel);
    }

    public reset(){
        this.hasSpecificChargingDays = this.webchargeConfigurationModel.hasSpecificChargingDays;
        this.chargingDays = this.webchargeConfigurationModel.chargingDays;
    }

    public hasChanges(){
        return this.hasSpecificChargingDays != this.webchargeConfigurationModel.hasSpecificChargingDays ||
            this.chargingDays != this.webchargeConfigurationModel.chargingDays;
    }

    public getDtoForUpdate(){
        let model = new WebchargeSettingDto()

        model.hasSpecificChargingDays = this.hasSpecificChargingDays;
        model.chargingDays = this.chargingDays;

        return model;
    }

    public setValues(webchargeConfigurationModel:WebchargeSettingDto){
        this.webchargeConfigurationModel = webchargeConfigurationModel;
        this.hasSpecificChargingDays = webchargeConfigurationModel.hasSpecificChargingDays;
        this.chargingDays = webchargeConfigurationModel.chargingDays;
    }

    public ResetErrors(){
        this.hasConfigurationError = false;
        this.configurationErrors = {};
    }

    public GetErrorsAsStringArray(){
        let errors = new Array<string>()
        for (const [_, value] of Object.entries(this.configurationErrors)) {
            errors.push(value.toString());
        }
        return errors
    }

    public getEnabledDates(val: string) {
        //parseInt um die führenden Nullen der Elemente 1-9 zu entfernen
        let splitDate = val.split('-');
        let day = parseInt(splitDate[2], 10);
        let month = parseInt(splitDate[1], 10);
        let year = parseInt(splitDate[0], 10);

        if (!this.hasSpecificChargingDays) {
            return true;
        }

        let isDayActivatedForWebcharges = this.chargingDays?.includes(day.toString()) ||
            (this.chargingDays?.includes(Constants.ULTIMO) &&
                HelperFunctions.getLastDayOfMonth(year, month) === day);

       return  isDayActivatedForWebcharges;
    }

}
